import Contract from '@/api/contract';
import STATUS from '@/constants/status';

export default {
  namespaced: true,
  state: {
    invoiceList: [],
  },
  mutations: {
    setInvoiceList(state, invoiceList) {
      state.invoiceList = invoiceList;
    },
  },
  actions: {
    async getInvoiceList({ commit }) {
      const res = await Contract.getInvoiceDetails();
      if (res.respCode === STATUS.SUCCESS && res.data) {
        commit('setInvoiceList', res.data);
      }
    },
  },
};
